import { Typography, styled } from '@mui/material';

export const ContainerW = styled('div')`
  position: relative;
  width: 100%;
  min-height: 325px;
  backgroundcolor: #fbfbfb;
  margin-bottom: 32px;

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
`;

export const Title = styled(Typography)`
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary.p080};

  @media (max-width: 1023px) {
    display: none;
  }
`;
